/**
 * Taille du texte de toute l'application, ajustable par paliers et gardée
 * d'une visite à l'autre.
 *
 * L'appli est en pixels fixes presque partout — pas en `rem` — donc changer la
 * taille de police à la racine ne suffirait pas à tout agrandir. Le `zoom`
 * CSS, lui, redimensionne la page entière comme le ferait un zoom de
 * navigateur : c'est le seul levier qui touche tout d'un coup, sans reprendre
 * chaque écran.
 */

const CLE = 'troc-taille-texte'

/** De 90 % (dense) à 180 % (grand), 100 % étant la taille d'origine. */
export const PALIERS_TAILLE = [90, 100, 110, 125, 140, 160, 180] as const

function borner(pourcent: number): number {
  return PALIERS_TAILLE.reduce((proche, p) =>
    Math.abs(p - pourcent) < Math.abs(proche - pourcent) ? p : proche,
  )
}

export function lireTaille(): number {
  const brut = Number.parseInt(localStorage.getItem(CLE) ?? '', 10)
  return Number.isFinite(brut) ? borner(brut) : 100
}

export function appliquerTaille(pourcent: number): number {
  const bornee = borner(pourcent)
  localStorage.setItem(CLE, String(bornee))
  document.documentElement.style.zoom = `${bornee}%`
  return bornee
}

/** À appeler une fois au démarrage, pour restaurer le dernier réglage. */
export function initTailleTexte(): void {
  document.documentElement.style.zoom = `${lireTaille()}%`
}
